import React, { Component } from 'react';
import database from './database';
import Asin from './Asin';
import Helmet from "react-helmet";

export default class AsinPage extends Component {
  render() {
    // const meta = {
    //   title: 'Some Meta Title',
    //   description: 'I am a description, and I can create multiple tags',
    //   canonical: 'http://example.com/path/to/page',
    //   meta: {
    //     charset: 'utf-8',
    //     name: {
    //       keywords: this.props.params.asin
    //     }
    //   }
    // };

// <Helmet
//                 htmlAttributes={{"lang": "en", "amp": undefined}} // amp takes no value
//                 title="My Title"
//                 titleTemplate="MySite.com - %s"
//                 defaultTitle="My Default Title"
//                 base={{"target": "_blank", "href": "http://mysite.com/"}}
//                 meta={[
//                     {"name": "description", "content": "Helmet application"},
//                     {"property": "og:type", "content": "article"}
//                 ]}
//                 link={[
//                     {"rel": "canonical", "href": "http://mysite.com/example"},
//                     {"rel": "apple-touch-icon", "href": "http://mysite.com/img/apple-touch-icon-57x57.png"},
//                     {"rel": "apple-touch-icon", "sizes": "72x72", "href": "http://mysite.com/img/apple-touch-icon-72x72.png"}
//                 ]}
//                 script={[
//                   {"src": "http://include.com/pathtojs.js", "type": "text/javascript"},
//                   {"type": "application/ld+json", innerHTML: `{ "@context": "http://schema.org" }`}
//                 ]}
//                 onChangeClientState={(newState) => console.log(newState)}
//             />

    const item = database.find( item => item.asin === this.props.params.asin );

    const meta = {
      meta: [
        { property: 'og:title', content: item.name } ,
        { property: 'og:url', content: `http://www.amzn.dance/asin/${this.props.params.asin}`} ,
        { property: 'og:description', content: item.reviews[0] } ,
        { property: 'og:image', content: item.images.small } 
      ]
    };

    

    return (
      <div>
        <Helmet {...meta} />
        <Asin {...item} />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/Asin-page.js
 **/